import { useQuery } from '@tanstack/vue-query';
import type { MaybeRef } from 'vue';
import { computed, toValue } from 'vue';
import type { Property } from '~/types/properties';

export const useShowcasePropertiesQuery = (enabled: MaybeRef<boolean>) => {
  const authStore = useAuthStore();

  return useQuery({
    queryKey: ['training', 'showcase-properties'],
    queryFn: async () => {
      return await $fetch<{ data: Property[]; total: number }>('/api/training/showcase-properties', {
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      });
    },
    enabled: computed(() => !!authStore.token && toValue(enabled)),
    staleTime: 120000,
  });
};
